import { render, staticRenderFns } from "./student-progress.vue?vue&type=template&id=e631b872&scoped=true&"
import script from "./student-progress.vue?vue&type=script&lang=js&"
export * from "./student-progress.vue?vue&type=script&lang=js&"
import style0 from "./student-progress.vue?vue&type=style&index=0&id=e631b872&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e631b872",
  null
  
)

export default component.exports